import { j as h } from "./jsx-runtime-3tyXYecC.mjs";
import { f as D } from "./index-LyFokDcn.mjs";
import { b as A, m as R } from "./tss-DN0acMKN.mjs";
import { M as p, d as g } from "./constants-CnFYFetN.mjs";
import { B as S } from "./Box-B5hjovXR.mjs";
import * as L from "react";
import { g as $, c as k } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { m as u } from "./memoTheme-BzXKG_-k.mjs";
import { g as M } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { s as b, u as W, c as I } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { g as V } from "./get-encore-value-Di648HqV.mjs";
function B(r) {
  return $("MuiDivider", r);
}
M("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]);
const T = (r) => {
  const {
    absolute: t,
    children: e,
    classes: i,
    flexItem: l,
    light: o,
    orientation: a,
    textAlign: n,
    variant: s
  } = r;
  return I({
    root: ["root", t && "absolute", s, o && "light", a === "vertical" && "vertical", l && "flexItem", e && "withChildren", e && a === "vertical" && "withChildrenVertical", n === "right" && a !== "vertical" && "textAlignRight", n === "left" && a !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", a === "vertical" && "wrapperVertical"]
  }, B, i);
}, j = b("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (r, t) => {
    const {
      ownerState: e
    } = r;
    return [t.root, e.absolute && t.absolute, t[e.variant], e.light && t.light, e.orientation === "vertical" && t.vertical, e.flexItem && t.flexItem, e.children && t.withChildren, e.children && e.orientation === "vertical" && t.withChildrenVertical, e.textAlign === "right" && e.orientation !== "vertical" && t.textAlignRight, e.textAlign === "left" && e.orientation !== "vertical" && t.textAlignLeft];
  }
})(u(({
  theme: r
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (r.vars || r).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: r.vars ? `rgba(${r.vars.palette.dividerChannel} / 0.08)` : A(r.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: r.spacing(2),
      marginRight: r.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: r.spacing(1),
      marginBottom: r.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(r.vars || r).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(r.vars || r).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), U = b("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (r, t) => {
    const {
      ownerState: e
    } = r;
    return [t.wrapper, e.orientation === "vertical" && t.wrapperVertical];
  }
})(u(({
  theme: r
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${r.spacing(1)} * 1.2)`,
  paddingRight: `calc(${r.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${r.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${r.spacing(1)} * 1.2)`
    }
  }]
}))), f = /* @__PURE__ */ L.forwardRef(function(t, e) {
  const i = W({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: l = !1,
    children: o,
    className: a,
    orientation: n = "horizontal",
    component: s = o || n === "vertical" ? "div" : "hr",
    flexItem: v = !1,
    light: x = !1,
    role: c = s !== "hr" ? "separator" : void 0,
    textAlign: w = "center",
    variant: y = "fullWidth",
    ...C
  } = i, d = {
    ...i,
    absolute: l,
    component: s,
    flexItem: v,
    light: x,
    orientation: n,
    role: c,
    textAlign: w,
    variant: y
  }, m = T(d);
  return /* @__PURE__ */ h.jsx(j, {
    as: s,
    className: k(m.root, a),
    role: c,
    ref: e,
    ownerState: d,
    "aria-orientation": c === "separator" && (s !== "hr" || n === "vertical") ? n : void 0,
    ...C,
    children: o ? /* @__PURE__ */ h.jsx(U, {
      className: m.wrapper,
      ownerState: d,
      children: o
    }) : null
  });
});
f && (f.muiSkipListHighlight = !0);
const N = R()((r, t) => {
  const { mode: e, palette: i, spacing: l } = r, { color: o, noGap: a, orientation: n } = t;
  return D.ifFeature(
    "encore",
    {
      root: {
        backgroundColor: "transparent",
        borderColor: e === p.Dye ? g.main : V(o, {
          "neutral-extra-weak": i.gray[200],
          "neutral-weak": i.gray[300],
          "neutral-medium": i.gray[400]
        }),
        height: "unset"
      }
    },
    {
      root: {
        backgroundColor: e === p.Dye ? g.main : i.gray[400],
        // Ensure global legacy `hr` `height: 1px` style isn't applied. See `main/ui-src/public/global/styles/_styles.css` for deprecation notice.
        height: "unset",
        "&.MuiDivider-light": {
          backgroundColor: e === p.Dye ? g.main : i.gray[300]
        },
        ...a ? {} : {
          margin: n === "vertical" ? `0 ${l(1)}` : `${l(2)} 0`
        }
      }
    }
  );
}), Q = (r) => {
  const { color: t = "neutral-medium", noGap: e, orientation: i, ...l } = r, { classes: o } = N({ color: t, noGap: e, orientation: i });
  return /* @__PURE__ */ h.jsx(S, { classes: o, component: f, "data-fabric-component": "Divider", orientation: i, ...l });
};
export {
  Q as D
};
//# sourceMappingURL=divider-Dq5lrAFK.mjs.map
